import { tourTypes } from './constants';

export const tourTypeTitle = (id) => {
    return tourTypes.find((x) => x.id === id)?.tourTypeName || 'Unknown';
};
